import { render, staticRenderFns } from "./FaturamentoGuiasTable.vue?vue&type=template&id=b8355bea&scoped=true"
import script from "./FaturamentoGuiasTable.vue?vue&type=script&lang=js"
export * from "./FaturamentoGuiasTable.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoGuiasTable.vue?vue&type=style&index=0&id=b8355bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8355bea",
  null
  
)

export default component.exports